import React, { FC } from 'react';

import { useI18n, useLogger, useSelector } from '~Hooks';
import { useStorage } from '~Components/Storage';
import HandySettingsBlock, { SettingBlockItemType } from '../../../Components/HandySettingsBlock';
import { useStaffContext } from '../../../Context/StaffProvider';

const ZoneSelection: FC = () => {
  const { i18n } = useI18n();
  const logger = useLogger('handy');
  const { authedStaff } = useStaffContext();

  const zones = useSelector((state) => state.zones);
  const [storage, updateStorage] = useStorage();

  if (!zones.length) {
    return null;
  }

  /** Persist the selected zone to storage so it survives across sessions/devices. Pass null to clear it. */
  const updateZone = (zoneId: string | null) => {
    logger.info('Updated zone', {
      staff: authedStaff,
      fromZone: storage.zoneId,
      toZone: zoneId,
    });

    updateStorage({ zoneId });
  };

  const zoneSettings: SettingBlockItemType[] = [
    {
      id: 'none',
      title: `${i18n('Settings.ZoneNone')} ${
        storage.zoneId === null ? `(${i18n('Handy.Active')})` : ''
      }`,
      action: {
        onClick: () => updateZone(null),
      },
    },
    ...zones.map((zone) => ({
      id: zone.id,
      title: `${zone.name} ${storage.zoneId === zone.id ? `(${i18n('Handy.Active')})` : ''}`,
      action: {
        onClick: () => updateZone(zone.id),
      },
    })),
  ];

  return <HandySettingsBlock items={zoneSettings} />;
};

export default ZoneSelection;
